import { useQuery } from "@tanstack/react-query";
import { Cartridge, MillSize } from "../models/Cartridge";
import {
	getCartridges,
	getMillSizes,
} from "../repositories/CartridgesRepository";

export const CARTRIDGES_QUERY_KEYS = {
	all: ["cartridges"] as const,
	list: (millSizeId: number | null) =>
		["cartridges", "list", millSizeId] as const,
	byId: (id: number | null) => ["cartridges", "detail", id] as const,
	millSizes: ["millSizes"] as const,
};

interface UseCartridgesProps {
	millSizeId?: number | null;
}

export const useCartridges = ({
	millSizeId = null,
}: UseCartridgesProps = {}) => {
	return useQuery<Cartridge[], Error>({
		queryKey: CARTRIDGES_QUERY_KEYS.list(millSizeId),
		queryFn: () => getCartridges({ millSizeId }),
	});
};

export const useMillSizes = () => {
	return useQuery<MillSize[], Error>({
		queryKey: CARTRIDGES_QUERY_KEYS.millSizes,
		queryFn: () => getMillSizes({ onlyActives: true }),
	});
};
